import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { ResetPasswordComponent } from './reset-password.component';

@NgModule({
  imports: [CommonModule, ResetPasswordRoutingModule, SharedModule],
  declarations: [ResetPasswordComponent],
  exports: [ResetPasswordComponent],
  providers: []
})
export class ResetPasswordModule {}
